module.exports = __webpack_public_path__ + "static/media/BrownLady.e27fcdba.jpg";